import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';

import { CheckboxDropdownOption } from '../../../../components/Dropdown';
import type { ContactDetailsFilterDto } from '../../../../domain/contact';
import { ContactDetailApiKey, isEmptyContactFilter } from '../../../../domain/contact';
import { StyledFilterSummary, StyledFilterName, StyledNotEmptyIndicator, StyledFilterDetails } from '../styles';

import {
  StyledFilterContactDetailsList,
  StyledFilterContactDetailsOption,
  StyledFilterContactDetailsSubtitle,
} from './styles';

export type ContactDetailsFilterProps = {
  isOpen: boolean;
  onToggle(): void;
  selectedContactDetails: ContactDetailsFilterDto;
  handleClickOnDetails(contactDetail: ContactDetailApiKey): void;
};

export const ContactDetailsFilter = (props: ContactDetailsFilterProps) => {
  const { isOpen, onToggle, selectedContactDetails, handleClickOnDetails } = props;
  const { t } = useTranslation();

  return (
    <div data-automation="ContactDetailsFilter" aria-expanded={isOpen}>
      <StyledFilterSummary isOpen={isOpen} onClick={onToggle}>
        <StyledFilterName>{t('contacts.filters.details.name')}</StyledFilterName>
        {!isEmptyContactFilter(selectedContactDetails) ? <StyledNotEmptyIndicator /> : null}
        <SWReactIcons iconName="chev-down" size="sm" />
      </StyledFilterSummary>
      <StyledFilterDetails isOpen={isOpen}>
        <StyledFilterContactDetailsSubtitle data-automation="ContactDetailsFilterSubtitle">
          {t('contacts.filters.details.subtitle')}
        </StyledFilterContactDetailsSubtitle>
        <StyledFilterContactDetailsList data-automation="ContactDetails">
          <CheckboxDropdownOption
            isSelected={selectedContactDetails.hasEmail}
            onClick={() => handleClickOnDetails(ContactDetailApiKey.Email)}
            variant="details"
          >
            <StyledFilterContactDetailsOption data-automation="ContactDetailsEmail">
              {t('contacts.filters.details.email')}
            </StyledFilterContactDetailsOption>
          </CheckboxDropdownOption>

          <CheckboxDropdownOption
            isSelected={selectedContactDetails.hasMobilePhone}
            onClick={() => handleClickOnDetails(ContactDetailApiKey.MobilePhone)}
            variant="details"
          >
            <StyledFilterContactDetailsOption data-automation="ContactDetailsMobilePhone">
              {t('contacts.filters.details.mobilephone')}
            </StyledFilterContactDetailsOption>
          </CheckboxDropdownOption>

          <CheckboxDropdownOption
            isSelected={selectedContactDetails.hasDirectPhone}
            onClick={() => handleClickOnDetails(ContactDetailApiKey.DirectPhone)}
            variant="details"
          >
            <StyledFilterContactDetailsOption data-automation="ContactDetailsDirectPhone">
              {t('contacts.filters.details.directphone')}
            </StyledFilterContactDetailsOption>
          </CheckboxDropdownOption>

          <CheckboxDropdownOption
            isSelected={selectedContactDetails.hasEmailAndMobilePhone}
            onClick={() => handleClickOnDetails(ContactDetailApiKey.EmailAndMobilePhone)}
            variant="details"
          >
            <StyledFilterContactDetailsOption data-automation="ContactDetailsBoth">
              {t('contacts.filters.details.email_and_mobile_phone')}
            </StyledFilterContactDetailsOption>
          </CheckboxDropdownOption>
        </StyledFilterContactDetailsList>
      </StyledFilterDetails>
    </div>
  );
};
